export default ":host {\n  background-color: #f1f1f1;\n}"